import { useFragment } from '@/generated';
import { ChatFieldsFragment, UserFieldsFragmentDoc } from '@/generated/graphql';
import { ChatMessage, MessageTypes } from '@/types';

const parseJson = (json: string) => {
  try {
    return JSON.parse(json);
  } catch {
    return json;
  }
};

const messagesFragment = (
  Message: ChatFieldsFragment,
  senderId?: string
): ChatMessage => {
  const readStat = (): boolean => {
    return Message.status?.some(
      (status) => status.user_id === senderId && status.status === 'READ'
    );
  };

  return {
    id: Message.id,
    message:
      Message.type === 'appointment'
        ? parseJson(Message.message)
        : Message.message,
    subText: Message.sub_text ?? undefined,
    options: Message.options,
    type: Message.type as MessageTypes,
    roomId: Message.room_id,
    tags: Message.tags ?? undefined,
    replyTo: Message.reply_to ?? undefined,
    referenceId: Message.reference_id ?? undefined,
    metadata: Message.metadata ?? undefined,
    from: useFragment(UserFieldsFragmentDoc, Message.sender).user_id,
    to: useFragment(UserFieldsFragmentDoc, Message.receiver).user_id,
    status: Message.status?.length
      ? Message.status.map((info) => ({
          chatId: info.chat_id ?? undefined,
          status: info.status ?? undefined,
          userId: info.user_id,
        }))
      : [],
    readStatus: readStat(),
    private: Message.private,
    createdAt: Message.created_at,
    updatedAt: Message.updated_at,
  };
};

export default messagesFragment;
